import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';

// Bootstrap Imports
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// Particles
import Particles from 'react-particles-js';

// Local Imports
import useWindowDimensions from '../hooks/useWindowDimensions';

const FooterSection = () => {
	// Component Hooks
	const { width } = useWindowDimensions();

	return (
		<div
			className='cta-particles-footer-background'
			style={{ position: 'relative' }}>
			<Particles
				height={width > 768 ? 450 : 500}
				params={{
					particles: {
						color: {
							value: 'rgba(255, 255, 255, 0.4)',
						},
						line_linked: {
							color: {
								value: 'rgba(255, 255, 255, 0.2)',
							},
						},
						number: {
							value: width > 768 ? 120 : 30,
						},
						size: {
							value: 1,
						},
					},
					interactivity: {
						events: {
							onhover: {
								enable: true,
								mode: 'repulse',
							},
						},
					},
					retina_detect: true,
				}}
				style={{ position: 'absolute', bottom: 0 }}
			/>
			<div
				style={{
					position: 'absolute',
					bottom: 0,
					height: '60%',
					width: '100%',
					background:
						'linear-gradient(0deg, rgb(27, 4, 65) 0%, rgba(27, 4, 65, 0.8) 50%, rgba(27, 4, 65, 0.247) 70%, rgba(27, 4, 65, 0) 100%)',
				}}>
				<div
					className='d-flex flex-column align-items-center justify-content-center'
					style={{ height: '100%' }}>
					<h1>
						<span className='majo-font-footer' style={{ color: '#fff' }}>
							Majo Cobos
						</span>
					</h1>
					<Row className='d-flex mt-4 mt-md-5 mx-0'>
						<Col xs={12} md={6} className='d-md-flex px-0'>
							<LinkContainer to='/home' className='bg-btn-web mx-1 my-1'>
								<div>Inicio</div>
							</LinkContainer>
							<LinkContainer to='/about' className='bg-btn-web mx-1 my-1'>
								<div>Conócenos</div>
							</LinkContainer>
						</Col>
						<Col xs={12} md={6} className='d-md-flex px-0'>
							<LinkContainer to='/courses' className='bg-btn-web mx-1 my-1'>
								<div>Cursos</div>
							</LinkContainer>
							<LinkContainer to='/contact' className='bg-btn-web mx-1 my-1'>
								<div>Contáctanos</div>
							</LinkContainer>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default FooterSection;
